"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// import asyncLoader from "cornerstone_ui_core/lib/components/AsyncLoader";
const AppRouter = props => {
  const {
    match,
    routes
  } = props;
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, routes.map((_ref, i) => {
    let {
      component: Comp = _reactRouterDom.Route,
      props
    } = _ref;
    const {
      component,
      renderElement,
      path,
      ...restProps
    } = props;
    return /*#__PURE__*/_react.default.createElement(Comp, {
      key: i,
      path: path ? "".concat(match.url + path) : null,
      // component: asyncLoader(props.component)
      component: typeof component === "function" ? /*#__PURE__*/_react.default.lazy(component) : component,
      render: () => /*#__PURE__*/_react.default.createElement(renderElement, {
        urlData: match,
        ...restProps
      })
    });
  }));
};
var _default = exports.default = AppRouter;